export default __webpack_public_path__ + "static/media/jujingyi.5f32df58.jpg";